// import { FaAsterisk } from "react-icons/fa";

import type { FormApi } from "@rvf/react";

type MyInputProps = {
  name: string;
  label: string;
  type: string;
  className?: string;
  readOnly?: boolean;
  disabled?: boolean;
  autoCorrect?: string;
  autoCapitalize?: string;
  onChange?: (value: string) => void;
  form: FormApi<any>;
};

export const RVFInput = ({
  name,
  label,
  type,
  className = "",
  readOnly = false,
  disabled = false,
  onChange,
  autoCorrect = "off",
  autoCapitalize = "off",
  form,
}: MyInputProps) => {
  // py-2
  return (
    <div className="mb-2">
      <label
        htmlFor={name}
        className="flex justify-between text-xs font-bold uppercase"
      >
        {label}
        {/* {required && <FaAsterisk />} */}
      </label>
      <input
        {...form.getInputProps(name, {
          id: name,
          readOnly: readOnly,
          disabled: disabled,
          onChange: (e: any) => onChange && onChange(e.target.value),
          autoCorrect: autoCorrect,
          autoCapitalize: autoCapitalize,
          autoComplete: "off",
          type: type,
        })}
        className={`mt-1 block w-full rounded-lg border border-gray-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-0 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-gray-400 ${className} ${form.error(name) ? "border-rose-600 dark:border-rose-400" : ""}`}
      />
      {form.error(name) && (
        <span className="text-xs text-rose-600 dark:text-rose-400">
          {form.error(name)}
        </span>
      )}
    </div>
  );
};
